import { FC } from 'react';

export interface IProps {
  routes: Array<any>;
}

export const Dashboard: FC<IProps> = () => {
  return <></>;
};
